import Footer from "../components/Footer";
import { formatPrice } from "../utils/formatPrice";

const ProductDetails = ({ product, onAddToCart, onToggleWishlist, isWishlisted }) => {
  return (
    <>
      <main className="page-shell product-page">
        <div className="section-container product-page-grid">
          <div className="product-page-media">
            <img src={product.image} alt={product.name} />
            <span>{product.category}</span>
          </div>

          <section className="product-page-copy">
                    <button className="back-to-shop" type="button" onClick={() => (window.location.hash = '#/shop')}>
                      ← Back to Shop
                    </button>
                    <p className="eyebrow">Product details</p>
            <h1>{product.name}</h1>
            <p>{product.description}</p>

            <div className="detail-benefits">
              {product.benefits.map((benefit) => (
                <span key={benefit}>{benefit}</span>
              ))}
            </div>

            <div className="product-page-rating">
              <strong>{product.rating}</strong>
              <span>Customer rating</span>
            </div>

            <div className="detail-price-row">
              <strong>{formatPrice(product.price)}</strong>
              <button type="button" onClick={() => onAddToCart(product)}>
                Add to Cart
              </button>
            </div>

            <button
              className="wishlist-page-btn"
              type="button"
              onClick={() => onToggleWishlist(product.id)}
            >
              {isWishlisted ? "Remove from Wishlist" : "Add to Wishlist"}
            </button>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ProductDetails;
